import React from 'react';
import PropTypes from 'prop-types';

import './Resources.scss';

import Layout from '../../../../components/Layout/Layout';
import EmployerPageLayout from '../../../../components/Employer/Layout/EmployerPageLayout/EmployerPageLayout';
import BasicDropdown from '../../../../components/Input/BasicDropdown/BasicDropdown';
import ArrowPagination from '../../../../components/Elements/ArrowPagination/ArrowPagination';
import ResourceContentCardGrid from '../../../../components/Employer/Layout/ResourceContentCardGrid/ResourceContentCardGrid';
import {
    rawMarketingTagsShape,
    resourcesShape,
} from '../../../../components/Includes/employerPropTypes';
import {
    SnowplowPageViewTracker,
    PAGE_VIEW_SECTIONS,
    PAGE_VIEW_TYPES,
    PAGE_TABS,
} from '../../../../components/Analytics/Snowplow/SnowplowPageViewTracker';
import { PAGE_DISPLAY_MODE } from '../../../constants';

export class Resources extends React.PureComponent {
    constructor(props) {
        super(props);

        this.currentLabel = this.getCurrentTagLabel(
            props.marketingTags,
            props.currentTagId
        );
        this.formattedTags = this.formatTags(
            props.marketingTags,
            props.currentTagId
        );
    }

    getCurrentTagLabel = (tags = [], currentTagId = null) => {
        let currentLabel = 'All subjects';

        const currentTag = tags.filter(
            (tag) => String(tag.id) === currentTagId
        );
        if (currentTag && currentTag.length) {
            currentLabel = currentTag[0].name;
        }

        return currentLabel;
    };

    formatTags = (tags = [], currentTagId = null) => {
        const formattedTags = tags.map((tag) => {
            const newTag = { ...tag };
            newTag.label = newTag.name;
            newTag.value = String(newTag.id);

            return newTag;
        });

        if (currentTagId) {
            const filteredTags = formattedTags.filter(
                (tag) => String(tag.id) !== currentTagId
            );

            const currentSelection = formattedTags.filter(
                (tag) => String(tag.id) === currentTagId
            );

            filteredTags.unshift({
                label: 'All subjects',
                value: '',
            });

            filteredTags.unshift(currentSelection[0]);

            return filteredTags;
        }

        return formattedTags;
    };

    handleSelectTag = (tagId) => {
        const basedUrl = '/employers-resources';
        const derivedUrl = tagId ? `${basedUrl}?tagId=${tagId}` : basedUrl;

        window.location.href = derivedUrl;
    };

    handlePagination = (paginationUrl) => {
        if (!paginationUrl) {
            return null;
        }

        return () => {
            const { currentTagId } = this.props;
            const derivedUrl = currentTagId
                ? `${paginationUrl}&tagId=${currentTagId}`
                : paginationUrl;

            window.location.href = derivedUrl;
        };
    };

    render() {
        const {
            resources,
            pagination: { startNum, endNum, total, nextUrl, prevUrl },
        } = this.props;

        return (
            <React.Fragment>
                <section className="filter-section">
                    <h2 className="filter-section__h2">Filter by subject</h2>

                    <BasicDropdown
                        cssClass="filter-section__dropdown"
                        options={this.formattedTags}
                        defaultLabel={this.currentLabel}
                        selectedValue={this.currentLabel}
                        onChange={this.handleSelectTag}
                    />
                </section>

                <section className="resources-section">
                    <h2 className="resources-section__h2">{`${total} Resources:`}</h2>

                    <hr className="resources-section__hr" />

                    <ResourceContentCardGrid resourceContent={resources} />
                </section>

                <section className="pagination-section">
                    <ArrowPagination
                        numberRange={`${startNum} - ${endNum}`}
                        total={total}
                        prevPage={this.handlePagination(prevUrl)}
                        nextPage={this.handlePagination(nextUrl)}
                    />
                </section>
            </React.Fragment>
        );
    }
}

export default (props) => {
    if (
        props.PAGE_PROPS.pageDisplayMode === PAGE_DISPLAY_MODE.EMPLOYER_DEFAULT
    ) {
        return (
            <div className="page-Employer-Marketing-Resources">
                <SnowplowPageViewTracker
                    pageSection={PAGE_VIEW_SECTIONS.EMPLOYER_RESOURCES}
                    pageType={PAGE_VIEW_TYPES.LANDING_PAGE}
                    pageTab={PAGE_TABS.RESOURCES}
                />
                <Layout
                    PAGE_PROPS={props.PAGE_PROPS}
                    className="employer-view-layout"
                >
                    <Resources {...props} />
                </Layout>
            </div>
        );
    }

    return (
        <div className="page-Employer-Marketing-Resources">
            <SnowplowPageViewTracker
                pageSection={PAGE_VIEW_SECTIONS.EMPLOYER_RESOURCES}
                pageType={PAGE_VIEW_TYPES.LANDING_PAGE}
                pageTab={PAGE_TABS.RESOURCES}
            />
            <EmployerPageLayout
                PAGE_PROPS={props.PAGE_PROPS}
                className="employer-resources-landing-layout"
            >
                <section className="header-section">
                    <h2 className="header-section__h2">EVERYTHING TO KNOW</h2>

                    <h1 className="header-section__h1">
                        Resources and tips to drive gender diversity in your
                        workplace
                    </h1>
                </section>

                <Resources {...props} />
            </EmployerPageLayout>
        </div>
    );
};

Resources.propTypes = {
    /**
     * current selected tag
     */
    currentTagId: PropTypes.number,
    /**
     * list of employers resources tag
     */
    marketingTags: rawMarketingTagsShape,
    /**
     * list of employers resources
     */
    resources: resourcesShape,
    /**
     * pagination data
     */
    pagination: PropTypes.shape({
        startNum: PropTypes.number,
        endNum: PropTypes.number,
        total: PropTypes.number,
        prevUrl: PropTypes.string,
        nextUrl: PropTypes.string,
    }),
};

Resources.defaultProps = {
    currentTagId: null,
    marketingTags: [],
    resources: [],
    pagination: {
        prevUrl: null,
        nextUrl: null,
    },
};
